export const SET_APP_START_INFO = 'SET_APP_START_INFO'; // Bot information

export const SET_CHAT_SUGGESTION_CONSENT_SHOWN = 'SET_MESSAGE_SUGGESTIONS_CONSENT_MODAL_SHOWN';
export const SET_CHAT_SUGGESTIONS_CONSENTS = 'SET_CHAT_SUGGESTIONS_CONSENTS';
export const SET_CHAT_SUGGESTIONS_CONSENTS_SUCCESS = 'SET_CHAT_SUGGESTIONS_CONSENTS_SUCCESS';

export const SET_THEME_DEFAULT = 'SET_THEME_DEFAULT';
export const SET_THEME_DEVICE_PREFERENCE = 'SET_THEME_DEVICE_PREFERENCE';
export const SET_THEME_PREFERENCE = 'SET_THEME_PREFERENCE';
export const SET_DISTANCE_UNIT = 'SET_DISTANCE_UNIT';

export const SET_IS_HUBBLE_DEBUGGER_ENABLED = 'SET_IS_HUBBLE_DEBUGGER_ENABLED';

export const SEND_TERMS_UPDATE_ACCEPTED = 'SEND_TERMS_UPDATE_ACCEPTED';

export const TOGGLE_CONSUMABLES = 'TOGGLE_CONSUMABLES';
export const TOGGLE_GOLD = 'TOGGLE_GOLD';
export const TOGGLE_PLATINUM = 'TOGGLE_PLATINUM';
export const TOGGLE_RECS_TOOLBAR = 'TOGGLE_RECS_TOOLBAR';
export const TOGGLE_TINDER_PLUS = 'TOGGLE_TINDER_PLUS';
